import { Grid, Stack, Text } from "@mantine/core";
import variables from "/styles/variables.module.scss";
import { purfifyHTML } from "@/services/services";
import { useEffect, useState } from "react";
import parse from "html-react-parser";

export default function Feature1({ options }) {
  const [title, setTitle] = useState(null);
  const [description, setDescription] = useState(null);
  const [data, setData] = useState([]);

  useEffect(() => {
    if (!options) return;
    if (options.title) setTitle(options.title);
    if (options.description) setDescription(options.description);
    if (options.data) setData(options.data);
  }, [options]);

  const headerJSX = (
    <Stack>
      {title && (
        <Text
          fz={title.fontSize ?? 48}
          fw={700}
          c={variables.primaryColor}
          ta={title.aligment ?? "center"}
        >
          {parse(purfifyHTML(title.text))}
        </Text>
      )}
      {description && (
        <Text
          fz={description.fontSize ?? 16}
          fw={400}
          ta={description.alignment && "center"}
        >
          {parse(purfifyHTML(description.text))}
        </Text>
      )}
    </Stack>
  );

  const gridJSX = data.length > 0 && (
    <Grid grow gutterXs={50} gutterSm={40} gutterLg={50}>
      {data.map((item, idx) => (
        <Grid.Col key={idx} xs={4} sm={3} md={1.5}>
          <Stack miw={"100%"} justify="space=between" align="center">
            <img
              src={item.imageUrl}
              alt="item image"
              width={"auto"}
              height={`100px`}
              style={{ objectFit: "contain" }}
            />
            <Text ta={"justify"}>{parse(purfifyHTML(item.text))}</Text>
          </Stack>
        </Grid.Col>
      ))}
    </Grid>
  );

  return (
    <Stack px={"4rem"} spacing={40} my={40}>
      {(title || description) && headerJSX}
      {data && gridJSX}
    </Stack>
  );
}
